import { CalendarRef, ConnectionCalendar } from '@griply/types';

export const getConnectionCalendar = (
  calendars: ConnectionCalendar[],
  ref: CalendarRef | null | undefined,
): ConnectionCalendar | undefined => {
  if (!ref) {
    return undefined;
  }
  return calendars.find(
    (calendar) =>
      calendar.id === ref.calendarId &&
      calendar.connectionId === ref.connectionId,
  );
};
